import { render } from "./ConversationLoader.vue?vue&type=template&id=23b394cb&scoped=true&ts=true"
import script from "./ConversationLoader.vue?vue&type=script&lang=ts"
export * from "./ConversationLoader.vue?vue&type=script&lang=ts"

import "./ConversationLoader.vue?vue&type=style&index=0&id=23b394cb&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b394cb"]])

export default __exports__